/* iter55p2 — Shared interp / materialize helpers.
 *
 * Extracted from TemplateVariablesDialog so GenreVariantPicker can
 * reuse `interp` without a circular import back into the dialog.
 */

/** Return an interpolated string. Arrays render as comma-joined values. */
export function interp(s, vars) {
  if (typeof s !== 'string') return s;
  return s.replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, (_, k) => {
    const v = vars[k];
    if (v == null || v === '') return `[${k}]`;
    if (Array.isArray(v))       return v.filter(Boolean).join(', ') || `[${k}]`;
    return String(v);
  });
}

/** Deep-copy `tpl` with every `{{tokens}}` replaced by `vars`. */
export function materialize(tpl, vars) {
  return {
    ...tpl,
    chapters:   (tpl.chapters   || []).map((c) => ({
      ...c,
      title:     interp(c.title,     vars),
      beat_note: interp(c.beat_note, vars),
      // iter55o — Also substitute inside alt_beats so twist rolls
      // still resolve {{external_threat}} etc.
      alt_beats: (c.alt_beats || []).map((a) => ({
        ...a,
        beat: interp(a.beat, vars),
      })),
    })),
    characters: (tpl.characters || []).map((c) => ({
      ...c,
      name:        interp(c.name,        vars),
      description: interp(c.description, vars),
    })),
  };
}
